import { ResponseUserType } from 'src/models/Account/User';
import { SafeAnyType } from 'src/utils/safeAny';
import { tryCatch } from 'src/utils/tryCatch';

export type PlusSubscriptionGoogleTagEvent = {
  event: string | null;
  email: string | null;
  country: string | null;
  group: string | null;
  reason: string | null;

  customer_type?: string | null;
  billing?: string | null;
  plan?: string | null;
  total?: string | null;
};

export type GTMAdditionalAttributesType = {
  user_id: ResponseUserType['ID'];
  first_name: ResponseUserType['FirstName'];
  last_name: ResponseUserType['LastName'];
  email: ResponseUserType['Email'];
  created_at: ResponseUserType['CreatedDate'];

  org_name?: ResponseUserType['OrganizationInfo']['CommonName'];
  org_id?: ResponseUserType['OrganizationInfo']['OrganizationIdString'];
  org_country?: ResponseUserType['OrganizationInfo']['CountryCode'];
  org_501c?: ResponseUserType['OrganizationInfo']['Is501C'];
  org_state?: ResponseUserType['OrganizationInfo']['RegionCode'];
  org_stripe_account_connected?: ResponseUserType['OrganizationInfo']['IsStripeConfigured'];
  amount_raised_online_annually?: ResponseUserType['OrganizationInfo']['AnnualRaiseLevel'];
  user_role?: string;
};

export type GTMConfirmTaxExemptStatusType = {
  event: 'confirm_501c';
};

export type GTMInviteTeammatesType = {
  event: 'invite_teammates';
  teammates: { email: string; role: string }[];
};

export type GTMProfileSaveType = {
  event: 'profile_saved';
  logo: 'populated' | 'blank';
  description: 'populated' | 'blank';
  website: 'populated' | 'blank';
  facebook: 'populated' | 'blank';
  twitter: 'populated' | 'blank';
  instagram: 'populated' | 'blank';
  address: 'populated' | 'blank';
  support_email: 'populated' | 'blank';
  support_phone: 'populated' | 'blank';
};

export type GTMBrandingSaveType = {
  event: 'branding_save';
  customize_domain: 'subdomain' | 'custom_domain' | 'off';
  header: 'populated' | 'blank';
  favicon: 'populated' | 'blank';
  email_logo: 'populated' | 'blank';
};

export type GTMAnalyticsIntegrationType = {
  event: 'analytics_integration';
  integration_type: 'meta' | 'google_analytics';
  integration_status: 'on' | 'off';
};

export type GTMCreateAccountFormType = {
  event: 'create_account_form';
  stage: 'Start Fundraising' | 'Submit';
};

export type GTMStripeAccountConnectedType = {
  event: 'stripe_connect';
  stage: 'existing_account' | 'not_connected' | 'new_account';
};

export type GTMStripeNonprofitRateType = {
  event: 'stripe_nonprofit_status';
  stage: 'nonprofit' | 'standard';
};

export class GoogleTagManager {
  static pushEvent(event: SafeAnyType): void {
    tryCatch(() => {
      window.dataLayer = window.dataLayer || [];
      if (window.dataLayer) {
        window.dataLayer.push(event);
      }
    });
  }
}
